export function snapshotSteps (questions) {
  return JSON.parse(JSON.stringify(questions || []))
}

function indexById (steps) {
  var map = {}
  steps.forEach(function (s, i) {
    if (s && s.id != null) {
      map[s.id] = i
    }
  })
  return map
}

export function describeStepChange (prevSnapshot, nextSnapshot) {
  var prev = prevSnapshot || []
  var next = nextSnapshot || []
  var prevIdx = indexById(prev)
  var nextIdx = indexById(next)
  var i

  for (i = 0; i < next.length; i++) {
    var n = next[i]
    if (!n || n.id == null) continue
    if (!Object.prototype.hasOwnProperty.call(prevIdx, n.id)) {
      return 'Added Step ' + (i + 1)
    }
    if (JSON.stringify(prev[prevIdx[n.id]]) !== JSON.stringify(n)) {
      return 'Changed Step ' + (i + 1)
    }
  }
  for (i = 0; i < prev.length; i++) {
    var p = prev[i]
    if (!p || p.id == null) continue
    if (!Object.prototype.hasOwnProperty.call(nextIdx, p.id)) {
      return 'Removed Step ' + (i + 1)
    }
  }
  if (JSON.stringify(prev) !== JSON.stringify(next)) {
    return 'Reordered steps'
  }
  return null
}
